import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMobileOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-[#E5E7EB] shadow-[0_1px_12px_rgba(0,0,0,0.06)]"
          : "bg-transparent"
      }`}
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2.5 cursor-pointer whitespace-nowrap">
          <img
            src="https://public.readdy.ai/ai/img_res/72f77137-917a-4a26-acda-4b5e849ad406.png"
            alt="Noveka AI Logo"
            className="h-[120px] w-[120px] object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {["Services", "Industries", "How It Works", "Contact"].map((item) => (
            <button
              key={item}
              onClick={() => scrollTo(item.toLowerCase().replace(/ /g, "-"))}
              className="text-[#6B7280] hover:text-[#1F2933] text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {item}
            </button>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => scrollTo("contact")}
            className="px-5 py-2 text-sm font-medium bg-[#4F46E5] text-white rounded-[10px] hover:bg-[#4338CA] hover:shadow-[0_4px_14px_rgba(79,70,229,0.35)] transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Deploy Your System
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl text-[#1F2933]`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-b border-[#E5E7EB] px-6 py-4 flex flex-col gap-4">
          {["Services", "Industries", "How It Works", "Contact"].map((item) => (
            <button
              key={item}
              onClick={() => scrollTo(item.toLowerCase().replace(/ /g, "-"))}
              className="text-[#1F2933] text-sm font-medium text-left cursor-pointer whitespace-nowrap"
            >
              {item}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contact")}
            className="px-5 py-2 text-sm font-medium bg-[#4F46E5] text-white rounded-[10px] text-center cursor-pointer whitespace-nowrap"
          >
            Deploy Your System
          </button>
        </div>
      )}
    </header>
  );
}
